import { RecommendedActionsBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpRecommendedActionsBlock } from './AmpRecommendedActionsBlock';
import { RecommendedActionsBlock } from './RecommendedActionsBlock';

export const RecommendedActionsBlockMapping: BlockMapping<RecommendedActionsBlockData> =
  {
    invariant: [],
    width: 'GRID',
    Component: RecommendedActionsBlock,

    AmpComponent: AmpRecommendedActionsBlock,
  };
